<template>
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">
                <i class="fas fa-images mr-2"></i>
                Photo Gallery
            </h1>
            <div>
                <router-link to="/photo-gallery/add" class="btn btn-primary">
                    <i class="fas fa-plus mr-1"></i> Add Photos
                </router-link>
            </div>
        </div>

        <!-- Photo Gallery List -->
        <PhotoGalleryList />

        <!-- Toast Messages -->
        <Toast />
    </div>
</template>

<script scoped>
import { defineComponent } from 'vue'
import PhotoGalleryList from '../../components/photo-gallery/PhotoGalleryList.vue'
import Toast from 'primevue/toast'

export default defineComponent({
    name: "PhotoGalleryPage",
    components: {
        PhotoGalleryList,
        Toast
    }
})
</script>

<style scoped>
.container-fluid {
    padding: 1.5rem;
}

@media (max-width: 576px) {
    .d-sm-flex {
        flex-direction: column;
        align-items: stretch !important;
        gap: 1rem;
    }
    
    .btn {
        width: 100%;
    }
}
</style>
